export const FLOW_GRAPH_SCHEMA_VERSION = 1;

export const FLOW_LIMITS = {
  maxNodes: 200,
  maxEdges: 400,
  maxLoopDepth: 2,
  maxMergeInputs: 10,
  maxSplitItems: 1000,
  maxLoopIterations: 1000,
  defaultLoopIterations: 20,
  maxWaitSec: 30 * 86_400,
  defaultUntilWaitSec: 7 * 86_400,
  defaultJoinTimeoutSec: 900,
  maxJoinTimeoutSec: 7 * 86_400,
  maxDedupeWindowSec: 7 * 86_400,
  maxIssues: 200,
  maxCodeChars: 262_144,
} as const;

export const ATTEMPT_TIMEOUT_SEC = { deliver: 30, action: 30, ai: 120 } as const;

export const AGENT_DONE_PORT = 'done';
export const AGENT_LIMIT_PORT = 'limit';

export const FORBIDDEN_PATH_SEGMENTS: readonly string[] = ['__proto__', 'constructor', 'prototype'];

export const NODE_KEY_PATTERN = /^[a-z][a-z0-9_]{0,39}$/;

// Merge inputs are "1".."N", so a port may start with a digit.
export const PORT_KEY_PATTERN = /^[a-z0-9][a-z0-9_]{0,31}$/;

export const MAIN_PORT = 'main';
export const ERROR_PORT = 'error';
export const WAIT_MAIN_PORT = 'ok';
export const CONTINUE_PORT = 'done';
// A step_stats row beside `done` counting its failures; the dot keeps it apart from any port key.
export const CONTINUED_FAILED_STAT = 'done.failed';

export type TOnError = 'stop' | 'continue';

export enum ENodeType {
  TRIGGER_WEBHOOK = 'trigger.webhook',
  TRIGGER_SCHEDULE = 'trigger.schedule',
  TRIGGER_MANUAL = 'trigger.manual',
  FILTER = 'filter',
  DEDUPE = 'dedupe',
  ROUTE = 'route',
  SPLIT = 'split',
  AGGREGATE = 'aggregate',
  MERGE = 'merge',
  LOOP = 'loop',
  WAIT = 'wait',
  CODE = 'code',
  SET = 'set',
  LOOKUP = 'lookup',
  DELIVER = 'deliver',
  ACTION = 'action',
  AI_GENERATE = 'ai.generate',
  AI_EXTRACT = 'ai.extract',
  AI_CLASSIFY = 'ai.classify',
  AI_AGENT = 'ai.agent',
}

export enum ENodeKind {
  TRIGGER = 'trigger',
  SYNC = 'sync',
  ASYNC = 'async',
  JOIN = 'join',
  CONTAINER = 'container',
}

export enum ENodeCategory {
  TRIGGER = 'trigger',
  LOGIC = 'logic',
  TRANSFORM = 'transform',
  AI = 'ai',
  SEND = 'send',
}

/** Terminal copy statuses a path may end in by itself (§3.2, §4.8); `merged` is never one. */
export type TCopyEndStatus =
  'completed' | 'failed' | 'error' | 'filtered' | 'duplicate' | 'stopped';

export type TSideEffects = 'none' | 'external';
